import {connectSubjectForm} from './subject-form-connect'
import {createSubjectFormReduxFormComponent} from './subject-form-redux-form'

export const createConnectedSubjectForm = ({formName}: {formName: string}) => {
  const ReduxFormComponent = createSubjectFormReduxFormComponent({formName})
  const ConnectedComponent = connectSubjectForm(ReduxFormComponent)
  return ConnectedComponent
}
export {IProps, IFormFields} from './subject-form-base'



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/components/subjects/subject-form/index.ts